module.exports = __webpack_public_path__ + "static/media/comm-close-search.fb0b0601.svg";